export enum HTTPrequestContentTypes {
  APPLICATION_JSON = 'application/json',
}

export enum HttpRequestVerbs {
  POST = 'POST',
  GET = 'GET',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export enum CHARSETS {
  UTF8 = 'utf-8',
}
